import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]

  confirmed(event) {
    if (event) {
      event.stopPropagation()
    }

    if (!this.hasStatusTarget) return

    const message = this.statusTarget.dataset.confirmMessage
    if (message) {
      this.statusTarget.textContent = message
    }

    this.statusTarget.classList.remove("hidden")
    this.statusTarget.setAttribute("role", "status")
    this.statusTarget.setAttribute("aria-live", "polite")
  }
}
